<div class="document-upload">
  <app-upload-document
    #uploadDocument
    [optionalFilesTitle]="'upload.optionalDecisions'"
    [documentType]="DocumentTypeEnum.DECISION"
  ></app-upload-document>
  <div class="options">
    <button
      mat-flat-button
      [disabled]="isCheckDisabled"
      [class.disabled]="isCheckDisabled"
      (click)="checkDecision()"
    >
      {{ 'button.checkDecision' | translate }}
    </button>
  </div>
</div>

@if (decisionExists) {
  <section class="check-result">
    @if (checkDecisionError) {
      <app-rerun-task (rerun)="rerun.emit()"></app-rerun-task>
    } @else {
      @if (checkedDecisionText) {
        <div class="checked-decision">
          <p>{{ checkedDecisionText }}</p>

          <app-work-process-selector
            [preselected]="preselectedWorkProcess"
            (workProcessSelected)="workProcessSelected.emit($event)"
          ></app-work-process-selector>

          <div class="action-buttons">
            <button
              mat-stroked-button
              [disabled]="!canUpload || isUploadInProgress || uploadDone"
              [class.disabled]="!canUpload || isUploadInProgress || uploadDone"
              (click)="uploadToSsd.emit()"
            >
              {{ 'button.uploadToSsd' | translate }}
            </button>
          </div>
        </div>
      } @else if (isCheckDecisionInProgress) {
        <div class="empty-checked-decision">
          <app-waiting [message]="'stepper.checkingDecision' | translate"></app-waiting>
        </div>
      }
    }
  </section>
}
